import { Answer } from "Models";
import { meetsThreshold } from "../_common/answerValidationHelper";
import includes from "ramda/es/includes";
import values from "ramda/es/values";
import head from "ramda/es/head";
import both from "ramda/es/both";
import equals from "ramda/es/equals";
import isEmpty from "ramda/es/isEmpty";
import pipe from "ramda/es/pipe";
import complement from "ramda/es/complement";
import { calculatePoints } from "./calculatePoints";

const log = (x) => {
  console.log(x);
  return x;
};

export default class ClickMatrixValidator {
  /**
   * 
   * @param {*} answer 
   * @returns true | false
   * 
   * will only checks if the W H O L E answer is correct
   * (might be dependent from the treshold)
   */
  static isAnswerCorrect(answer) {
    const answers = answer.userInput();
    const expectedAnswers = answer.correctAnswers(); // = [{ "?":["x", "y"] }, ...]

    if (!answers || answers.length < 1) return false;

    const findTargetList = (key) => head(values(expectedAnswers[key - 1]));

    const nonEmptyExpectedAnswers = expectedAnswers.filter(
      pipe(values, head, complement(isEmpty))
    );
    const expectedCount = () => nonEmptyExpectedAnswers.length;


    /* standard click-matrixes are evaluation that only
      when the whole line is correct, the user get 1 point */
    if (answer.lineEvaluation()) {
      /* searches the correct answers for the given key */

      /* checks if every value in answered is correct */
      const isTaskCorrect = (a) =>
        a.value.every((v) => includes(v.toString(), findTargetList(a.key)));

      /* check if the lengths match */
      const hasTaskCorrectLength = (a) =>
        a.value.length === findTargetList(a.key).length;

      /* results includes for every line if this line is correct */
      const results = answers.map(both(isTaskCorrect, hasTaskCorrectLength));

      /* now we search the other way round, has the user not forgot to fill a line */
      const areAllCorrect = () => results.every(equals(true));

      const areAllAnswered = () =>
        results.length === nonEmptyExpectedAnswers.length;

      /* this is need only if countPerAnswer is set for this question */
      const countCorrectOnes = () => results.filter(equals(true)).length;

      /**
       * we might put correct only if all lines are correct
       * or we check if we have fullfilled the required trashold
       */
      return !answer.countPerAnswer()
        ? areAllCorrect() && areAllAnswered()
        : meetsThreshold(countCorrectOnes(), expectedCount());
    } else {

      const correctCtr = calculatePoints(answer);

      return correctCtr >= answer.question().realQuestionsCount();
    }
  }
}
